import { EclipseFooter } from "@/components/EclipseChrome";

/** Subpage footer: Eclipse footer plus a solutions column for subpage discovery. */
const Footer = () => <EclipseFooter />;

export default Footer;
